import {
  USUARIO_CONTRASENA_EXITO,
  USUARIO_CONTRASENA_ERROR,
  RESET_USUARIO_CONTRASENA,
  COMENZAR_USUARIO_CONTRASENA,
} from "../types";

// cada reducer tiene su propio state
const initialState = {
  error: false,
  errorMessage: null,
  loading: false,
  resultado: null,
};

function usuarioReducer(state = initialState, action) {
  switch (action.type) {
    case COMENZAR_USUARIO_CONTRASENA:
      return {
        ...state,
        loading: action.payload,
      };
    case USUARIO_CONTRASENA_EXITO:
      return {
        ...state,
        loading: false,
        resultado: action.payload,
      };
    case USUARIO_CONTRASENA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    case RESET_USUARIO_CONTRASENA:
      return initialState;
    default:
      return state;
  }
}

export default usuarioReducer;
